import React, { useState, useEffect } from "react";
import {
  Typography,
  Container,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  ListItemText,
  MenuItem,
  Card,
  CardHeader,
  CardContent,
  Chip,
  Tooltip,
  Snackbar,
  Alert,
  TablePagination
} from "@mui/material";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ShareIcon from "@mui/icons-material/Share";
import ChatIcon from "@mui/icons-material/Chat";
import InfoIcon from "@mui/icons-material/Info";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Rating from '@mui/material/Rating';
import IdeaChatDialog from "../ideaChatDialog";
import { useNavigate } from "react-router-dom";
import Footer from '../Materials/Footer';
import BurgerBar from '../Materials/BurgerBar';
import { useAuth } from '../../context/AuthContext';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function ListIdeas() {
  const { user, isRestrictedUser } = useAuth();
  const [allIdeas, setAllIdeas] = useState([]);
  const [myIdeas, setMyIdeas] = useState([]);
  const [sharedIdeas, setSharedIdeas] = useState([]);
  const [receivedIdeas, setReceivedIdeas] = useState([]);
  const [advices, setAdvices] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [ideaToDelete, setIdeaToDelete] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const navigate = useNavigate();
  const [showReceivedIdeasDetails, setShowReceivedIdeasDetails] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [ideaToConfirm, setIdeaToConfirm] = useState(null);
  const [users, setUsers] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);

  // Estados para paginação das tabelas
  const [sharedPage, setSharedPage] = useState(0);
  const [sharedRowsPerPage, setSharedRowsPerPage] = useState(4);
  const [myPage, setMyPage] = useState(0);
  const [myRowsPerPage, setMyRowsPerPage] = useState(4);
  const [receivedPage, setReceivedPage] = useState(0);
  const [receivedRowsPerPage, setReceivedRowsPerPage] = useState(4);

  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);
  const [currentIdeaComments, setCurrentIdeaComments] = useState({ id: null, comments: '' });
  const [openClearConfirmDialog, setOpenClearConfirmDialog] = useState(false);

  const [openChatDialog, setOpenChatDialog] = useState(false);
  const [currentIdeaChat, setCurrentIdeaChat] = useState(null);

  const [rejectionReason, setRejectionReason] = useState('');

  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
const [selectedIdeaDetails, setSelectedIdeaDetails] = useState(null);
const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

const showNotification = (message, severity = 'success') => {
  setNotification({
    open: true,
    message,
    severity
  });
};

const handleCloseNotification = () => {
  setNotification((prev) => ({
    ...prev,
    open: false
  }));
};
const handleOpenDetailsDialog = (idea) => {
  setSelectedIdeaDetails(idea);
  setOpenDetailsDialog(true);
};

const handleCloseDetailsDialog = () => {
  setOpenDetailsDialog(false);
  setSelectedIdeaDetails(null);
};

  const handleOpenChatDialog = (ideaId) => {
    setCurrentIdeaChat(ideaId);
    setOpenChatDialog(true);
  };

  const [ideaToEdit, setIdeaToEdit] = useState({
  id: null,
  project_name: '',
  acronym_name: '',
  keywords: '',
  objectives: '',
  description: '',
  innovation_level: '',
  budget: '',
  advice_id: '',
  co_authors: []
});

  const handleClearComments = async () => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${currentIdeaComments.id}/comments/clear`, {
        method: 'PATCH'
      });

      if (response.ok) {
        const updatedIdea = await response.json();
        // Atualiza todos os estados relevantes
        setAllIdeas(allIdeas.map(idea =>
          idea.id === updatedIdea.id ? updatedIdea : idea
        ));
        setSharedIdeas(sharedIdeas.map(idea =>
          idea.id === updatedIdea.id ? { ...idea, user_comments: null } : idea
        ));
        setReceivedIdeas(receivedIdeas.map(idea =>
          idea.id === updatedIdea.id ? { ...idea, user_comments: null } : idea
        ));
        setCurrentIdeaComments({ id: null, comments: '' });
        setOpenClearConfirmDialog(false);
        setOpenCommentsDialog(false);
        showNotification('Comments cleared successfully!', 'success');
      } else {
        console.error("Failed to clear comments");
        showNotification('Failed to clear comments.', 'error');
      }
    } catch (error) {
      console.error("Error clearing comments:", error);
      showNotification('An error occurred while clearing comments.', 'error');
    }
  };
  
const sendCommentNotification = async (ideaId, commentUserId) => {
  try {
    const response = await fetch('https://api.hub4food.colab4food.com/api/send-idea-comment-notification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ideaId,
        commentUserId
      })
    });

    if (!response.ok) {
      console.error('Failed to send notifications');
    }
    return await response.json();
  } catch (error) {
    console.error('Error sending notifications:', error);
  }
};

  const handleOpenCommentsDialog = async (ideaId) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${ideaId}`);
      if (response.ok) {
        const ideaData = await response.json();
        setCurrentIdeaComments({
          id: ideaId,
          comments: ideaData.user_comments || ''
        });
        setOpenCommentsDialog(true);
      } else {
        console.error("Failed to fetch idea comments");
      }
    } catch (error) {
      console.error("Error fetching idea comments:", error);
    }
  };

  const handleCloseCommentsDialog = () => {
    setOpenCommentsDialog(false);
    setCurrentIdeaComments({ id: null, comments: '' });
  };

  const handleCommentsChange = (e) => {
    setCurrentIdeaComments({ ...currentIdeaComments, comments: e.target.value });
  };

  const handleSaveComments = async () => {
  try {
    const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${currentIdeaComments.id}/comments`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_comments: currentIdeaComments.comments
      })
    });

    if (response.ok) {
      const updatedIdea = await response.json();
      
      // Atualiza todos os estados relevantes
      setAllIdeas(allIdeas.map(idea =>
        idea.id === updatedIdea.id ? updatedIdea : idea
      ));
      setSharedIdeas(sharedIdeas.map(idea =>
        idea.id === updatedIdea.id ? { ...idea, user_comments: updatedIdea.user_comments } : idea
      ));
      setReceivedIdeas(receivedIdeas.map(idea =>
        idea.id === updatedIdea.id ? { ...idea, user_comments: updatedIdea.user_comments } : idea
      ));
      
      // Envia notificação por email
      await sendCommentNotification(updatedIdea.id, user.userId);
      
      handleCloseCommentsDialog();
      showNotification('Comments saved successfully!', 'success');
    } else {
      console.error("Failed to update comments");
      showNotification('Failed to save comments.', 'error');
    }
  } catch (error) {
    console.error("Error updating comments:", error);
    showNotification('An error occurred while saving comments.', 'error');
  }
};

  const handleAcceptIdea = async (ideaId) => {
    try {
      // Update the status in users_idea table
      const response = await fetch(`https://api.hub4food.colab4food.com/api/users_idea/${user.userId}/${ideaId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: true })
      });

      if (response.ok) {
        // Update the local state to reflect the change
        setReceivedIdeas(receivedIdeas.map(idea =>
          idea.id === ideaId ? { ...idea, status: true } : idea
        ));
        showNotification('Idea accepted successfully!', 'success');
      } else {
        console.error("Failed to accept idea");
        showNotification('Failed to accept idea.', 'error');
      }
    } catch (error) {
      console.error("Error accepting idea:", error);
      showNotification('An error occurred while accepting the idea.', 'error');
    }
  };

  const handleRejectIdea = async (ideaId, reason) => {
    try {
      // Primeiro rejeita a ideia
      const response = await fetch(`https://api.hub4food.colab4food.com/api/users_idea/${user.userId}/${ideaId}`, {
        method: 'DELETE'
      });
  
      if (response.ok) {
        // Se houver uma razão, adiciona ao chat
        if (reason) {
          const rejectionMessage = `The person has rejected this idea. This is the reason:\n- ${reason}`;
          
          await fetch(`https://api.hub4food.colab4food.com/api/ideas/${ideaId}/chat`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              userId: user.userId,
              message: rejectionMessage,
              isSystemMessage: true // Adicione esta flag se quiser marcar como mensagem do sistema
            })
          });
        }
  
        setReceivedIdeas(receivedIdeas.filter(idea => idea.id !== ideaId));
        setRejectionReason(''); // Limpa o motivo após a rejeição
        showNotification('Idea rejected successfully!', 'success');
      } else {
        console.error("Failed to reject idea");
        showNotification('Failed to reject idea.', 'error');
      }
    } catch (error) {
      console.error("Error rejecting idea:", error);
      showNotification('An error occurred while rejecting the idea.', 'error');
    }
  };

  const handleOpenConfirmDialog = (idea) => {
    setIdeaToConfirm(idea);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
    setIdeaToConfirm(null);
  };

  const handleEmailChange = (event) => {
    setSelectedEmails(event.target.value);
  };

  // Fetch received ideas
  useEffect(() => {
    const fetchReceivedIdeas = async () => {
      if (!user?.userId) return;

      try {
        // First get the user_idea relations with status
        const relationsResponse = await fetch(`https://api.hub4food.colab4food.com/api/user_idea/user/${user.userId}`);
        if (relationsResponse.ok) {
          const relations = await relationsResponse.json();

          // Then fetch each idea and include the status and sharing user_id
          const ideasPromises = relations.map(async (relation) => {
            const ideaResponse = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${relation.id_idea}`);
            if (ideaResponse.ok) {
              const ideaData = await ideaResponse.json();
              return {
                ...ideaData,
                status: relation.status,
                shared_by_user_id: relation.user_id 
              };
            }
            return null;
          });

          const ideas = await Promise.all(ideasPromises);
          setReceivedIdeas(ideas.filter(idea => idea !== null));
        }
      } catch (error) {
        console.error("Error fetching received ideas:", error);
      }
    };

    fetchReceivedIdeas();
  }, [user]);

  // Fetch all ideas
  useEffect(() => {
    const fetchAllIdeas = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/ideas');
        if (response.ok) {
          const data = await response.json();
          setAllIdeas(data);
        }
      } catch (error) {
        console.error("Error fetching ideas:", error);
      }
    };

    fetchAllIdeas();
  }, []);

  // Filter ideas when allIdeas or user changes
  useEffect(() => {
    if (user && allIdeas.length > 0) {
      // Filter user's own ideas and ideas where user is co-author
      const userIdeas = allIdeas.filter(idea =>
        idea.user_id === user.userId ||
        (idea.co_authors && idea.co_authors.includes(user.userId))
      );
      setMyIdeas(userIdeas);

      // Filter shared ideas where is_shared is true
      const shared = allIdeas.filter(idea =>
        idea.is_shared === true && idea.user_id === user.userId
      );
      setSharedIdeas(shared);
    }
  }, [allIdeas, user]);

  // Fetch advices
  useEffect(() => {
    const fetchAdvices = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/advices');
        if (response.ok) {
          const data = await response.json();
          setAdvices(data);
        }
      } catch (error) {
        console.error("Error fetching advices:", error);
      }
    };

    fetchAdvices();
  }, []);

  // Fetch all users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch('https://api.hub4food.colab4food.com/api/users');
        if (response.ok) {
          const data = await response.json();
          setUsers(data);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  // Menu handlers
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenDrawer(false);
  };

  const handleExit = () => {
    localStorage.removeItem("user");
    navigate("/");
  };

  // Delete handlers
  const handleOpenDeleteDialog = (id) => {
    const idea = allIdeas.find((idea) => idea.id === id);
    setIdeaToDelete(idea);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setIdeaToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${ideaToDelete.id}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        setAllIdeas(allIdeas.filter((idea) => idea.id !== ideaToDelete.id));
        setOpenDeleteDialog(false);
        setIdeaToDelete(null);
        showNotification('Idea deleted successfully!', 'success');
      } else {
        console.error("Failed to delete idea:", response.statusText);
        showNotification('Failed to delete idea.', 'error');
      }
    } catch (error) {
      console.error("Error deleting idea:", error);
      showNotification('An error occurred while deleting the idea.', 'error');
    }
  };

  const handleRatingChange = async (ideaId, newRating) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${ideaId}/rating`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ rating: newRating })
      });

      if (response.ok) {
        const updatedIdea = await response.json();
        setAllIdeas(allIdeas.map(idea =>
          idea.id === updatedIdea.id ? updatedIdea : idea
        ));
        setMyIdeas(myIdeas.map(idea =>
          idea.id === updatedIdea.id ? updatedIdea : idea
        ));
        showNotification('Rating updated successfully!', 'success');
      } else {
        console.error("Failed to update rating");
        showNotification('Failed to update rating.', 'error');
      }
    } catch (error) {
      console.error("Error updating rating:", error);
      showNotification('An error occurred while updating the rating.', 'error');
    }
  };

  // Edit handlers
  const handleOpenEditDialog = async (id) => {
    try {
      const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${id}`);
      if (response.ok) {
        const data = await response.json();

        // Busca os detalhes dos usuários co-autores
        const coAuthorsDetails = data.co_authors && data.co_authors.length > 0
          ? users.filter(user => data.co_authors.includes(user.id))
          : [];

        setIdeaToEdit({
          ...data,
          co_authors: data.co_authors || [] // Garante array vazio se não existir
        });
        setOpenEditDialog(true);
      }
    } catch (error) {
      console.error("Error fetching idea:", error);
    }
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setIdeaToEdit(null);
  };

  const handleSaveEdit = async () => {
  try {
    const response = await fetch(`https://api.hub4food.colab4food.com/api/ideas/${ideaToEdit.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        project_name: ideaToEdit.project_name,
        acronym_name: ideaToEdit.acronym_name,
        keywords: ideaToEdit.keywords,
        objectives: ideaToEdit.objectives,
        description: ideaToEdit.description,
        innovation_level: ideaToEdit.innovation_level,
        budget: ideaToEdit.budget,
        advice_id: ideaToEdit.advice_id,
        co_authors: ideaToEdit.co_authors || []
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      showNotification(errorData.message || 'Failed to update idea', 'error');
      return;
    }

    const updatedIdea = await response.json();
    
    setAllIdeas(allIdeas.map(idea =>
      idea.id === updatedIdea.id ? updatedIdea : idea
    ));
    setMyIdeas(myIdeas.map(idea =>
      idea.id === updatedIdea.id ? updatedIdea : idea
    ));
    
    showNotification('Idea updated successfully!', 'success');
    
    setTimeout(() => {
      setOpenEditDialog(false);
      setIdeaToEdit({
        id: null,
        project_name: '',
        acronym_name: '',
        keywords: '',
        objectives: '',
        description: '',
        innovation_level: '',
        budget: '',
        advice_id: '',
      
        co_authors: []
      });
    }, 1000);
  } catch (error) {
    showNotification('Network error while updating idea', 'error');
    console.error("Error updating idea:", error);
  }
};

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setIdeaToEdit(prev => ({ ...prev, [name]: value }));
  };

  const handleCoAuthorsChange = (event) => {
    const { value } = event.target;
    // value contém os IDs dos usuários selecionados
    setIdeaToEdit(prev => ({ ...prev, co_authors: value }));
  };

  // Share handler - redirects to sharedIdea page with idea ID
  const handleShareIdea = (ideaId) => {
    navigate("/sharedidea", { state: { ideaId } });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Navbar */}
     <BurgerBar />


      {/* Main Content */}
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
        {/* Shared Ideas Card */}
        {sharedIdeas.length > 0 && (
          <Card sx={{ mb: 4, boxShadow: 3 }}>
            <CardHeader
              title="Shared Ideas"
              avatar={<ShareIcon color="primary" />}
              titleTypographyProps={{
                variant: "h6",
                fontWeight: "bold",
                color: "primary"
              }}
              subheader="Ideas you've shared with others"
            />
            <CardContent>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>Title</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>Description</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>Budget</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>Calls</TableCell>
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>Comments</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sharedIdeas.slice(sharedPage * sharedRowsPerPage, sharedPage * sharedRowsPerPage + sharedRowsPerPage).map((idea) => {
                      const advice = advices.find(a => a.id === idea.advice_id);
                      return (
                        <TableRow key={idea.id}>
                          <TableCell align="center">{idea.project_name}</TableCell>
                          <TableCell align="center">{idea.description}</TableCell>
                          <TableCell align="center">{idea.budget} €</TableCell>
                          <TableCell align="center">
                            {advice ? (
                              <Chip
                                label={advice.title}
                                color="primary"
                                size="small"
                              />
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="primary"
                              onClick={() => handleOpenChatDialog(idea.id)}
                            >
                              <ChatIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="primary"
                              onClick={() => handleOpenEditDialog(idea.id)}
                            >
                              <EditIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[4, 8, 12, 16]}
                component="div"
                count={sharedIdeas.length}
                rowsPerPage={sharedRowsPerPage}
                page={sharedPage}
                onPageChange={(event, newPage) => setSharedPage(newPage)}
                onRowsPerPageChange={(event) => {
                  setSharedRowsPerPage(parseInt(event.target.value, 10));
                  setSharedPage(0);
                }}
                labelRowsPerPage="Lines per page:"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                }
              />
            </CardContent>
          </Card>
        )}

        {/* My Ideas Card - só mostra se NÃO for RestrictedUser */}
{!isRestrictedUser && (
  <Card sx={{ boxShadow: 3 }}>
    <CardHeader
      title="My Ideas"
      avatar={<LightbulbIcon color="primary" />}
      titleTypographyProps={{
        variant: "h6",
        fontWeight: "bold",
        color: "primary"
      }}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => navigate("/createIdea")}
          sx={{ mr: 2 }}
        >
          New Idea
        </Button>
      }
    />
    <CardContent>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>Title</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>Description</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>Budget</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>Calls</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Evaluation
                <Tooltip 
                  title={
                    <div>
                      <div>1 Star - Very poor idea, not feasible</div>
                      <div>2 Stars - Poor idea, major issues</div>
                      <div>3 Stars - Average idea, needs improvement</div>
                      <div>4 Stars - Good idea, promising</div>
                      <div>5 Stars - Excellent idea, highly feasible</div>
                    </div>
                  } 
                  placement="top"
                  arrow
                >
                  <InfoIcon fontSize="small" sx={{ ml: 0.5, verticalAlign: 'middle', color: 'action.active' }} />
                </Tooltip>
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }} align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {myIdeas.slice(myPage * myRowsPerPage, myPage * myRowsPerPage + myRowsPerPage).map((idea) => {
              const advice = advices.find(a => a.id === idea.advice_id);
              const isOwner = idea.user_id === user.userId;
              const owner = users.find(u => u.id === idea.user_id);

              return (
                <TableRow key={idea.id}>
                  <TableCell align="center">
                    {idea.project_name}
                    {!isOwner && (
                      <Typography variant="caption" display="block" color="text.secondary">
                        Create by: {owner ? owner.name : `User ${idea.user_id}`}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center">{idea.description}</TableCell>
                  <TableCell align="center">{idea.budget} €</TableCell>
                  <TableCell align="center">
                    {advice ? (
                      <Chip
                        label={advice.title}
                        color="primary"
                        size="small"
                      />
                    ) : "-"}
                  </TableCell>
                  <TableCell align="center">
                    <Rating
                      name={`rating-${idea.id}`}
                      value={idea.rating || 0}
                      onChange={(event, newValue) => {
                        if (newValue !== null) {
                          handleRatingChange(idea.id, newValue);
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction="row" spacing={1} justifyContent="center">
                      <IconButton
                        color="primary"
                        onClick={() => handleOpenEditDialog(idea.id)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="secondary"
                        onClick={() => handleShareIdea(idea.id)}
                      >
                        <ShareIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleOpenDeleteDialog(idea.id)}
                        disabled={!isOwner} // Só o dono pode deletar
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              );
            })}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[4, 8, 12, 16]}
              component="div"
              count={myIdeas.length}
              rowsPerPage={myRowsPerPage}
              page={myPage}
              onPageChange={(event, newPage) => setMyPage(newPage)}
              onRowsPerPageChange={(event) => {
                setMyRowsPerPage(parseInt(event.target.value, 10));
                setMyPage(0);
              }}
              labelRowsPerPage="Lines per page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
              }
            />
          </CardContent>
        </Card>
)}

       {receivedIdeas.length > 0 && (
  <Card sx={{ mt: 4, boxShadow: 3 }}>
    <CardHeader
      title="Received Ideas"
      avatar={<ShareIcon color="secondary" />}
      titleTypographyProps={{ variant: "h6", fontWeight: "bold", color: "secondary" }}
      subheader="Ideas shared with you by others"
    />
    <CardContent>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {receivedIdeas.some(idea => idea.status) ? (
                <>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Title</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Description</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Budget</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Calls</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Shared by</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Comments</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">Status</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">Details</TableCell>
                </>
              ) : (
                <>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Title</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold" }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="center">Actions</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {receivedIdeas.slice(receivedPage * receivedRowsPerPage, receivedPage * receivedRowsPerPage + receivedRowsPerPage).map((idea) => {
              if (!idea.status) {
                return (
                  <TableRow key={idea.id}>
                    <TableCell>{idea.project_name}</TableCell>
                    <TableCell>
                      <Chip label="New Idea Received" color="info" size="small" />
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" spacing={1} justifyContent="center">
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => handleAcceptIdea(idea.id)}
                          sx={{ minWidth: 40 }}
                        >
                          ✓
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => setIdeaToConfirm(idea) || setOpenConfirmDialog(true)}
                          sx={{ minWidth: 40 }}
                        >
                          ✕
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              }

              const advice = advices.find(a => a.id === idea.advice_id);
              const sharingUser = users.find(u => u.id === idea.shared_by_user_id);

              return (
                <TableRow key={idea.id}>
                  <TableCell align="center">{idea.project_name}</TableCell>
                  <TableCell align="center">{idea.description}</TableCell>
                  <TableCell align="center">{idea.budget} €</TableCell>
                  <TableCell align="center">
                    {advice ? (
                      <Chip label={advice.title} color="secondary" size="small" />
                    ) : "-"}
                  </TableCell>
                  <TableCell align="center">
                    {sharingUser ? sharingUser.name : `User #${idea.shared_by_user_id}`}
                  </TableCell>
                  <TableCell align="center">
  <IconButton
    color="primary"
    onClick={() => handleOpenChatDialog(idea.id)}
  >
    <ChatIcon />
  </IconButton>
</TableCell>
                  <TableCell align="center">
                    <Chip label="Accepted" color="success" size="small" />
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="primary"
                      onClick={() => handleOpenDetailsDialog(idea)}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[4, 8, 12, 16]}
        component="div"
        count={receivedIdeas.length}
        rowsPerPage={receivedRowsPerPage}
        page={receivedPage}
        onPageChange={(event, newPage) => setReceivedPage(newPage)}
        onRowsPerPageChange={(event) => {
          setReceivedRowsPerPage(parseInt(event.target.value, 10));
          setReceivedPage(0);
        }}
        labelRowsPerPage="Lines per page:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
        }
      />
    </CardContent>
  </Card>
)}
      </Container>
        {/* Received Ideas Card */}

      {/* Comments Dialog */}
      <Dialog open={openCommentsDialog} onClose={handleCloseCommentsDialog} fullWidth maxWidth="md">
        <DialogTitle>Edit Comments</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            rows={6}
            value={currentIdeaComments.comments}
            onChange={handleCommentsChange}
            placeholder="Add your comments about this idea..."
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => currentIdeaComments.comments ? setOpenClearConfirmDialog(true) : null}
            color="error"
            disabled={!currentIdeaComments.comments}
          >
            Clear
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Button onClick={handleCloseCommentsDialog}>Cancel</Button>
          <Button onClick={handleSaveComments} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <IdeaChatDialog
        open={openChatDialog}
        onClose={() => setOpenChatDialog(false)}
        ideaId={currentIdeaChat}
        userId={user?.userId}
        users={users}
      />

      {/* Confirm Rejection Dialog */}
      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle>Confirm Rejection</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to reject the idea "{ideaToConfirm?.project_name}"?
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Please provide a reason for rejection (optional):
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            placeholder="Enter your reason for rejecting this idea..."
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
          />
          <Typography variant="body2" sx={{ mt: 2 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleRejectIdea(ideaToConfirm.id, rejectionReason);
              handleCloseConfirmDialog();
            }}
            color="error"
          >
            Reject
          </Button>
        </DialogActions>
      </Dialog>

      {/* Clear Comments Confirmation Dialog */}
      <Dialog open={openClearConfirmDialog} onClose={() => setOpenClearConfirmDialog(false)}>
        <DialogTitle>Confirm Clear Comments</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to clear all comments for this idea?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenClearConfirmDialog(false)}>Cancel</Button>
          <Button onClick={handleClearComments} color="error">Clear</Button>
        </DialogActions>
      </Dialog>

     {/* Delete Dialog */}
<Dialog
  open={openDeleteDialog}
  onClose={handleCloseDeleteDialog}
>
  <DialogTitle>
    Delete Idea
  </DialogTitle>

  <DialogContent>
    <Typography>
      Are you sure you want to delete the idea
      <strong> "{ideaToDelete?.project_name}"</strong>?
    </Typography>

    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ mt: 1 }}
    >
      This action cannot be undone.
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={handleCloseDeleteDialog}
      color="inherit"
    >
      Cancel
    </Button>

    <Button
      onClick={handleConfirmDelete}
      color="error"
      variant="contained"
    >
      Delete
    </Button>
  </DialogActions>
</Dialog>

      {/* Edit Dialog */}
{/* Edit Dialog */}
<Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
  <DialogTitle>Edit Idea</DialogTitle>
  <DialogContent>
    {ideaToEdit &&
      <>
        <TextField
          fullWidth
          label="Project Name"
          name="project_name"
          value={ideaToEdit.project_name || ""}
          onChange={handleEditChange}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Acronym Name"
          name="acronym_name"
          value={ideaToEdit.acronym_name || ""}
          onChange={handleEditChange}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Keywords"
          name="keywords"
          value={ideaToEdit.keywords || ""}
          onChange={handleEditChange}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Objectives"
          name="objectives"
          value={ideaToEdit.objectives || ""}
          onChange={handleEditChange}
          multiline
          rows={3}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={ideaToEdit.description || ""}
          onChange={handleEditChange}
          multiline
          rows={4}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Innovation Level"
          name="innovation_level"
          value={ideaToEdit.innovation_level || ""}
          onChange={handleEditChange}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          label="Budget"
          name="budget"
          type="number"
          value={ideaToEdit.budget || ""}
          onChange={handleEditChange}
          sx={{ mt: 2 }}
        />
        <TextField
          select
          fullWidth
          label="Calls"
          name="advice_id"
          value={ideaToEdit.advice_id || ""}
          onChange={handleEditChange}
          sx={{ mt: 2 }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {advices.map((advice) => (
            <MenuItem key={advice.id} value={advice.id}>
              {advice.title}
            </MenuItem>
          ))}
        </TextField>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Partners</InputLabel>
          <Select
            multiple
            value={ideaToEdit.co_authors || []}
            onChange={handleCoAuthorsChange}
            label="Partners"
            renderValue={(selected) => {
              const selectedUsers = users.filter(user => selected.includes(user.id));
              return selectedUsers.map(user => user.email).join(', ');
            }}
          >
            {users.map(user => (
              <MenuItem key={user.id} value={user.id}>
                <Checkbox checked={ideaToEdit.co_authors?.includes(user.id) || false} />
                <ListItemText primary={user.email} secondary={user.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </>
    }
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseEditDialog} color="error">
      Cancel
    </Button>
    <Button onClick={handleSaveEdit} color="primary">
      Save
    </Button>
  </DialogActions>
</Dialog>

{/* Idea Details Dialog */}
<Dialog open={openDetailsDialog} onClose={handleCloseDetailsDialog} maxWidth="md" fullWidth>
  <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Idea Details</DialogTitle>
  <DialogContent>
    {selectedIdeaDetails && (
      <Box sx={{ mt: 2 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Project Name
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.project_name}
            </Typography>
          </Box>
          
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Acronym Name
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.acronym_name || '-'}
            </Typography>
          </Box>
          
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Keywords
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.keywords || '-'}
            </Typography>
          </Box>
          
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Objectives
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.objectives || '-'}
            </Typography>
          </Box>
          
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Description
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.description}
            </Typography>
          </Box>
          
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Innovation Level
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.innovation_level || '-'}
            </Typography>
          </Box>
          
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              Budget
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {selectedIdeaDetails.budget} €
            </Typography>
          </Box>
        </Stack>
      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseDetailsDialog} color="error">Close</Button>
  </DialogActions>
</Dialog>

      <Box>
   
<Snackbar
  open={notification.open}
  autoHideDuration={4000}
  onClose={handleCloseNotification}
  anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center'
  }}
>
  <Alert
    onClose={handleCloseNotification}
    severity={notification.severity}
    variant="filled"
    sx={{ width: '100%' }}
  >
    {notification.message}
  </Alert>
</Snackbar>
        <Footer />
      </Box>
    </Box>
  );
}